export const queue = {
  type: {
    all: {
      title: 'Semua',
      description: 'Panggilan ke semua operator.'
    },
    random: {
      title: 'Acak',
      description: 'Panggilan ke operator secara acak.'
    }
  }
};
